var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$apollo.loading)?_c('div',[_c('spinner')],1):_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"screen-title mb-0",attrs:{"xs12":""}},[_c('span',[_vm._v("Event Entries")])]),_c('v-flex',[_c('div',{staticClass:"mb-32 title-description"},[_vm._v("\n          Here you can see all the attendees of your event which have checked in.\n        ")])]),_c('v-flex',{attrs:{"xs12":""}},[_c('data-table',{attrs:{"items":_vm.attendees,"item-clickable":"","headers":[
            { text: 'Name', align: 'left', value: 'firstName' },
            { text: 'Last name', align: 'left', value: 'lastName' },
            { text: 'Status', align: 'left', value: 'status' },
            { text: 'Time of entry', align: 'left', value: 'createdAt' },
          ]},on:{"item-click":function($event){return _vm.goTo(_vm.routes.organizer.editAccreditation, {
              eventId: _vm.eventId,
              accreditationId: $event.id,
            })}}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }